var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"disabled":_vm.selectDisabled,"placeholder":_vm.placeholder,"value":_vm.selected,"options":_vm.options,"clearable":false,"searchable":false},on:{"input":_vm.onSelectChange},scopedSlots:_vm._u([{key:"open-indicator",fn:function(){return [_c('caret-icon',{attrs:{"width":8,"height":6}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }